/**
 * Title for an iframe JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class TitleForIframe
 */
class TitleForIframe {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.iframeContainer = $( '#js-sidebar-iframe' );
        this.titleForIframe  = this.iframeContainer.attr( 'srtitle' );
        this.iframe          = this.iframeContainer.find( 'iframe' );
    }

    /**
     * This gives the containers srtitle attribute to the iframes title.
     */
    giveTitleToIframe() {
        this.iframe.attr( 'title', this.titleForIframe );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.giveTitleToIframe();
    }
}

// Export the class reference.
module.exports = TitleForIframe;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/titleforiframe.js